<template lang="pug">
  v-menu(
    v-model="menu"
    :disabled="disabled"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px")
    template(v-slot:activator="{ on }")
      ValidationProvider(:rules="rules" v-slot="{ errors }")
        v-text-field(
          v-model="dateFormatted"
          readonly
          :disabled="disabled"
          v-on="on"
          :error="errors.length > 0")
          template(v-slot:label)
            v-icon.pr-1(v-if="isRequired" color="red accent-2" size="12") mdi-asterisk
            v-icon.pr-1(:color="getColorError(errors.length)" size="22") mdi-calendar
            | {{ label }}
        span.red--text.text--accent-2(v-if="errors.length > 0")
          v-icon(color="red accent-2") mdi-alert
          |  {{ errors[0] }}
    v-date-picker(
      v-model="date"
      no-title
      scrollable
      :locale="$i18n.locale"
      :first-day-of-week="1"
      @input="dateSelected()")
</template>

<script>
  export default {
    name: "BaseDatePicker",
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      rules: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      }
    },
    data:() => ({
      menu: false,
      dateFormatted: null,
      date: null,
    }),
    computed: {
      isRequired(){
        return this.rules.includes('required');
      }
    },
    watch: {
      value: function(val){
        this.dateFormatted = val;
        if (val != '' && val != null) {
          this.date = this.getFormatDate(val);
        }
      }
    },
    created(){
      this.dateFormatted = this.value;
      if (this.value != '' && this.value != null) {
        this.date = this.getFormatDate(this.value);
      }
    },
    methods:{
      getColorError(error){
        return error > 0 ? 'red accent-2' : '';
      },
      getFormatDateFormatted(date){
        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      },
      getFormatDate(date){
        const [day, month, year] = date.split('/');
        return `${year}-${month}-${day}`;
      },
      dateSelected(){
        this.menu = false;
        this.dateFormatted = this.getFormatDateFormatted(this.date);
        this.$emit('input', this.dateFormatted);
      },
    },
  }
</script>

<style lang="sass">
</style>